import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Nodo } from "../models/nodo.model";
import { Observable } from "rxjs";
import { elemSubGraph } from "../models/elemSubGraph.model";
import { LexicalEntry } from "../models/lexicalEntry.model";

@Injectable({ providedIn: 'root' })
export class DataStorageService {
    constructor(private http: HttpClient) { }

    // servizio dettagli nodo panel box
    fetchInfoNode(nodoId: string): Observable<Nodo> {
        return this.http.get<Nodo>('LexO-backend-beta/service/graphViz/' + nodoId + '/nodeSummary?key=lexodemo');
    }

    // servizio dettagli edge panel box
    fetchInfoEdge(source: string, relation: string, target: string) {
        return this.http.post<elemSubGraph>(
            'LexO-backend-beta/service/graphViz/edgeGraph?key=lexodemo'
            , { relation, source, target }
        );
    }

    // servizio recupero sotto grafo in base al tipo di relazione scelta
    fetchSubGraph(nodoId: string, relation: string, lenght: number, direction: string) {
        return this.http.post<elemSubGraph>(
            'LexO-backend-beta/service/graphViz/' + nodoId + '/nodeGraph?key=lexodemo'
            , { relation, lenght, direction }
        );
    }

    // servizio recupero lista sensi
    fetchLexicalSense(text: string, searchMode: string, type: string, field: string, pos: string,
        formType: string, author: string, lang: string, status: string, offset: number, limit: number) {
        return this.http.post<LexicalEntry>(
            'LexO-backend-beta/service/lexicon/data/lexicalSenses'
            , { text, searchMode, type, field, pos, formType, author, lang, status, offset, limit }
        );
    }

    // servizio recupero distanza max 
    fetchNodeMaxHops(relation: string, node: string, direction: string) {
        return this.http.post<any>(
            'LexO-backend-beta/service/graphViz/hopsByRel?key=lexodemo'
            , { relation, node, direction }
        );
    }

    // servizio cammino minimo tra due nodi
    // /minPath?key=lexodemo&source=USem1737zampa&target=USem918essere&inference=true' \
    // key=lexodemo&source=USem1737zampa&target=USem918essere&false=
    fetchMinPath(sourceId: string, targetId: string, inference:boolean){
        return this.http.post<any>(
            'LexO-backend-beta/service/graphViz/minPath?key=lexodemo&source=' + sourceId + '&target=' + targetId+'&inference='+inference,
            { sourceId, targetId, inference}
        );
    }

}